module.exports = __webpack_public_path__ + "static/media/50.0309ad7a.jpg";